import { render, staticRenderFns } from "./MergeEqualGoodsBizInfo.vue?vue&type=template&id=0c3f3fba&scoped=true&"
import script from "./MergeEqualGoodsBizInfo.vue?vue&type=script&lang=js&"
export * from "./MergeEqualGoodsBizInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f3fba",
  null
  
)

export default component.exports